import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button, Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { authService, userService } from '../../services/firebaseService';
import logger from '../../utils/logger';
// Importer le CSS pour les icônes Bootstrap
import 'bootstrap-icons/font/bootstrap-icons.css';

const SimpleNavbar = () => {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = authService.onAuthStateChanged(async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        try {
          // Récupérer les données complètes du profil utilisateur
          const profileData = await userService.getUserProfile();
          setUserProfile(profileData.user);
        } catch (error) {
          logger.error('Erreur lors de la récupération du profil:', error);
        }
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await authService.logout();
      navigate('/login');
    } catch (error) {
      logger.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
      <Container>
        <Navbar.Brand as={Link} to="/">Tournoi Manager</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {!loading && (
            <>
              {user ? (
                <>
                  <Nav className="me-auto">
                    <Nav.Link as={Link} to="/">Tableau de bord</Nav.Link>
                    <Nav.Link as={Link} to="/tournaments">Tournois</Nav.Link>
                    <Nav.Link as={Link} to="/athletes">Athlètes</Nav.Link>
                    <Nav.Link as={Link} to="/subscription" className="text-warning">
                      <i className="bi bi-star-fill me-1"></i>Abonnement
                    </Nav.Link>
                  </Nav>
                  <Nav className="ms-auto">
                    <Dropdown align="end">
                      <Dropdown.Toggle variant="outline-light" id="dropdown-user">
                        <i className="bi bi-person-circle me-1"></i>
                        {user.displayName || user.email}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} to="/profile">Mon profil</Dropdown.Item>
                        <Dropdown.Item as={Link} to="/subscription">Gérer mon abonnement</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={handleLogout}>Déconnexion</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Nav>
                </>
              ) : (
                <Nav className="ms-auto">
                  <Nav.Link as={Link} to="/login">Connexion</Nav.Link>
                  <Nav.Link as={Link} to="/register">Inscription</Nav.Link>
                </Nav>
              )}
            </>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default SimpleNavbar;
